import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Breadcrumbs } from 'js/components/design-system';
import { lawyerTypesBreadcrumbsHistory } from './functions';

const LawyerTypeBreadcrumbs = () => {
  const location = useLocation();
  const { t } = useTranslation();
  return (
    <Breadcrumbs
      className="lawyer-type-breadcrumbs"
      history={lawyerTypesBreadcrumbsHistory(t, location)}
    />
  );
};

export default LawyerTypeBreadcrumbs;
